const normalizeFilterValue = (value, key = "id") => {
    if (value === null || value === undefined) return value;

    // string or number → return as-is
    if (typeof value === "string" || typeof value === "number") {
        return value;
    }

    // array → extract key
    if (Array.isArray(value)) {
        return value
            .map(v => {
                if (typeof v === "object" && v !== null) {
                    return v[key] ?? null;
                }
                return v;
            })
            .filter(v => v !== null && v !== "");
    }

    // object → extract key
    if (typeof value === "object") {
        return value[key] ?? value;
    }

    return value;
}

const normalizeFilters = (filters = {}, keyMap = {}) => {
    const normalized = {};

    Object.entries(filters).forEach(([filterKey, value]) => {
        const extractKey = keyMap[filterKey] || "id";
        const finalValue = normalizeFilterValue(value, extractKey);

        // skip empty values
        if (
            finalValue === null ||
            finalValue === undefined ||
            (Array.isArray(finalValue) && finalValue.length === 0) ||
            finalValue === ""
        ) {
            return;
        }

        normalized[filterKey] = finalValue;
    });

    return normalized;
}

export default normalizeFilters;